import CameraCodes from '@/data/TRACCIA_FINALE_TROVACOLLEGIO_03_Camera.json';
import SenateCodes from '@/data/TRACCIA_FINALE_TROVACOLLEGIO_03_Senato.json';
import { StructureType } from '@/lib/model';

export type Code = keyof typeof CameraCodes[0] & keyof typeof SenateCodes[0];

// Get party code label
export const getCodeLabel = (type: StructureType, code: Code) => {
  if (type === StructureType.CAMERA) {
    return CameraCodes[0][code];
  }

  return SenateCodes[0][code];
};
